<template>
  <div class="active_table" ref="content">
    <toolbar>
      <div class="search" style="width: 100%">
        <div class="label" style="margin-left: 10px">数据筛选：</div>
        <Select v-model="search.area" @on-change="searchFunc" style="width: 7.8em" placeholder="请选择区域" clearable>
          <Option v-for="item in areaList" :value="item.value" :key="item.value">{{
              item.name
          }}</Option>
        </Select>
        -
        <Select v-model="search.showType" @on-change="searchFunc" style="width: 7.8em" placeholder="请选择告警类型" clearable>
          <Option v-for="item in statusList" :value="item.id" :key="item.id">{{
              item.name
          }}</Option>
        </Select>
        -
        <Select v-model="search.keepTime" @on-change="searchFunc" style="width: 7.8em" placeholder="请选择持续时间" clearable>
          <Option v-for="item in timeSegmentationList" :value="item.value" :key="item.value">{{
              item.name
          }}</Option>
        </Select>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer :page-size="40" @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align: right; margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
  padding-top: 2em;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../../../p_company/components/toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            title: "企业名称",
            key: "companyName",
            align: "center",
          },
          {
            title: "站点名称",
            key: "siteName",
            align: "center",
          },
          {
            title: "设备名称",
            key: "contentTypeName",
            align: "center",
          },
          {
            title: "异常状态",
            key: "typeName",
            align: "center",
          },
          {
            title: "异常生成时间",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm")
                ),
              ]);
            },
          },
          {
            title: "持续时间",
            key: "orderBy",
            align: "center",
          },
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null,
      },
      search: {
        area: null,
        showType: null,
        keepTime: null
      },
      timeSegmentationList: [
        {
          name: "半小时",
          value: 30
        },
        {
          name: "1小时",
          value: 60
        },
        {
          name: "2小时",
          value: 120
        },
        {
          name: "6小时",
          value: 360
        },
        {
          name: "24小时",
          value: 1440
        }
      ],
      statusList: [
        { id: 1, name: "预告警" },
        { id: 2, name: "断电" },
      ],
      areaList: [], //区域列表 group
      siteList: [], // 站点枚举列表
      companyList: [], // 企业列表
    };
  },
  components: {
    toolbar
  },
  created: async function () {
    this.getCompany(); // 获取企业列表 //await
    this.getCompanyGroupList(); //获取企业分组
    window.addEventListener("resize", this.tableInit);
  },
  methods: {
    getData() {
      // 获取数据
      var that = this;
      this.table.loading = true;
      this.$api.Warn.getCurrentWarnSummaryList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search,
        },
        [null, null]
      ).then((res) => {
        if (res.code == 0) {
          var _list = [];
          // 获取成功
          res.data.list.forEach(function (item, index, self) {
            for (let i = 0; i < that.companyList.length; i++) {
              if (item.uuid == that.companyList[i].uuid) {
                item.companyName = that.companyList[i].name;
                break;
              }
            }
            for (let j = 0; j < that.siteList.length; j++) {
              if (item.siteId == that.siteList[j].id) {
                item.siteName = that.siteList[j].name;
                break;
              }
            }
            _list.push(item);
          });
          this.table.data = _list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 表格高度计算
    tableInit() {
      this.$nextTick(() => {
        if (this.$route.path != "/ahome/currentWarnSummary") {
          window.removeEventListener("resize", this.tableInit);
          return false;
        }
        let tableH = this.$refs.content.clientHeight;
        let headerH = emComputed(9.5); // 操作栏5.5em转换px， 2em的上下边距分页组件
        this.table.maxHeight = tableH - headerH - 32; // 32px的分页组件高度
      });
    },
    // 获取站点枚举值
    getSiteList() {
      this.$api.Enum.getSiteEnum({ content: { uuid: this.search.uuid } }, [null, "park"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
          this.getData();  //
          this.tableInit(); // 表格初始化
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取企业列表
    getCompany() {
        this.$api.A_Company.getCompanyHomeList(null, ["uuids", "park"]).then(
          res => {
            if (res.code == 0) {
              this.companyList = res.data;
              this.getSiteList();
            } else {
              this.$Notice.warning({
                title: "获取企业列表失败",
                desc: res.message || "请联系管理员"
              });
            }
          }
        );
    },
    // 获取站点枚举值
    getCompanyGroupList() {
      this.$api.Enum.getCompanyGroupEnum(null, [null, "park"]).then(res => {
        if (res.code == 0) {
          this.areaList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取企业分组枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
  },
};
</script>